<mat-expansion-panel style="margin-bottom: 2px;" [expanded]="isExpanded" (expandedChange)="onExpandedChange($event)" data-cy="tdo-accordion-item-expansion-panel">
  <mat-expansion-panel-header data-cy="tdo-accordion-item-expansion-panel-header">
    <mat-panel-title style="color: white; height: 34px;" data-cy="tdo-accordion-item-panel-title">
      <ng-content select="app-tdo-accordion-item-header">
      </ng-content>
    </mat-panel-title>
  </mat-expansion-panel-header>
  <ng-content select="app-tdo-accordion-item-content">
  </ng-content>
</mat-expansion-panel>
